import React, { useEffect, useState } from 'react';

import SimpleModalOrMobilePage from '#/components/basic/modal/SimpleModalOrMobilePage';
import { generateQrCodeFromText } from '#/lib/qrCode/generateQr';
import { useSelector } from '#/reduxState/storeCore';

async function importAndGenerateQr(text: string) {
  return generateQrCodeFromText(text, {
    scale: 4,
    color: {
      dark: '#FFF',
      light: '#0D111D', // = var(--elevation-light)
    },
  });
}

export default function WalletConnectQrModal() {
  const unlockWalletConnectQRUrl = useSelector(
    state => state.walletDetail.unlockWalletConnectQRUrl
  );

  const [qr, setQr] = useState('');

  useEffect(() => {
    if (!unlockWalletConnectQRUrl) {
      return;
    }
    importAndGenerateQr(unlockWalletConnectQRUrl).then(setQr);
  }, [unlockWalletConnectQRUrl]);

  if (!unlockWalletConnectQRUrl) {
    return null;
  }

  return (
    <SimpleModalOrMobilePage
      title="Connect WalletConnect"
      size="small"
      zIndex={99999123}
      // onClose={() => {
      //   staticDispatch(showWalletConnectQR(undefined));
      // }}
    >
      <div
        style={{
          minHeight: 300,
          maxWidth: 500,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        {qr && <img src={qr} style={{ width: '100%' }} />}
      </div>
    </SimpleModalOrMobilePage>
  );
}
